/**
=========================================================
* Material Kit 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import { useState } from "react";
// Material Kit 2 PRO React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";
import MKInput from "../../../components/MKInput";
import MKButton from "../../../components/MKButton";

// Authentication layout components
import CoverLayout from "../../../shared/components/Layouts/CoverLayout";

// Images
import bgImage from "../../../assets/images/prizesCover.png";

//Redux Methods
import { useDispatch } from "react-redux";
import { resetPassword } from "../../../redux/modules/user";
import { useNavigate } from "react-router-dom";

function Cover() {
    
  const rDispatch = useDispatch();
  const [formData, updateFormData] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    updateFormData({
      ...formData,

      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });
  };
  const placeSubmitHandler = (event) => {
    event.preventDefault();
    rDispatch(resetPassword(formData,navigate))
  };
  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card style={{backgroundColor: " #FF7412"}}>
        <MKBox
          variant="gradient"
          bgColor="dark"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MKTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Restablecer Contraseña
          </MKTypography>
          <MKTypography display="block" variant="button" color="white" my={1}>
            Recibirás un Email en un máximo de 60 segundos
          </MKTypography>
        </MKBox>
        <MKBox pt={4} pb={3} px={3}>
          <MKBox component="form" role="form" onSubmit={placeSubmitHandler}>
            <MKBox mb={4}>
              <MKInput
                type="email"
                name="email"
                label="Email"
                variant="standard"
                fullWidth
                InputLabelProps={{ shrink: true }}
                onChange={handleChange}
                placeholder="john@email.com"
              />
            </MKBox>
            <MKBox mt={6} mb={1}>
              <MKButton variant="gradient" color="dark" type="submit" fullWidth>
                Restablecer
              </MKButton>
            </MKBox>
          </MKBox>
        </MKBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
